<template>
    <div class="lab-treatment-view">
        <lab-sub-header />

        <div class="treatment-center-content">
            <performance-table
                v-if="
                    currentView === views.PERFORMANCE_TABLE || currentView === views.ISTANBUL_TABLE
                "
            />

            <treatment-page-main-body v-if="currentView === views.WELL_CARDS" />

            <compare-wells v-if="currentView === views.COMPARE_WELLS" />
        </div>
        <emr-sync-button v-if="showEmrSyncButton" />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { TREATMENT_PAGE_VIEWS } from '../../business/const'
import PerformanceTable from './PerformanceTable'
import LabSubHeader from './LabSubHeader'
import CompareWells from './CompareWells'
import EmrSyncButton from './EmrSyncButton'
import TreatmentPageMainBody from './TreatmentPageMainBody'

export default {
    name: 'LabTreatmentView',
    components: {
        TreatmentPageMainBody,
        EmrSyncButton,
        CompareWells,
        LabSubHeader,
        PerformanceTable
    },
    data() {
        return {
            delayedVideoAlertClosedByUser: false
        }
    },
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment,
            currentView: state => state.navigation.currentView
        }),
        ...mapGetters({
            tenant: 'common/getTenant',
            showDemoDisclaimer: 'common/showDemoDisclaimer',
            isFdaFriendly: 'common/isFdaFriendly',
            isTooEarlyForScores: 'timelapse/isTooEarlyForScores'
        }),
        views() {
            return TREATMENT_PAGE_VIEWS
        },
        showEmrSyncButton() {
            return this.tenant && this.tenant.emrType
        }
    }
}
</script>

<style lang="scss" scoped>
.lab-treatment-view {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .treatment-center-content {
        height: calc(100% - #{$sub-header-height});
    }
}
</style>
